import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesSupportTickets } from "../../constants/enums";
import { TicketNote } from "./ticketNotes.types";

export const requestGetTicketNotes = async (
  ticketId: string,
): Promise<TicketNote[]> => {
  return await instance.get(
    buildUrl(ApiRoutesSupportTickets.Tickets, ticketId, "notes"),
  );
};

export const requestAddTicketNote = async ({
  ticketId,
  text,
}: {
  ticketId: string;
  text: string;
}): Promise<TicketNote> => {
  return await instance.post(
    buildUrl(ApiRoutesSupportTickets.Tickets, ticketId, "notes"),
    { text },
  );
};
